(function(win) {
  var doc = win.document;
  var docEl = doc.documentElement;
  var tid;
  
  function refreshRem() {
    var width = docEl.getBoundingClientRect().width;
    const isPC = !/Mobi|Android|Silk\/|Kindle|BlackBerry|Opera Mini|IEMobile|Mobile|Tablet/i.test(navigator.userAgent);
    if (isPC) {
      width = 750;
    }else{
      width = width > 750 ? 750 : width;
    }

    // var rem = width / 10; // 将屏幕宽度分为10份， 1份为1rem
    var rem = width / 750; // 将屏幕宽度分为10份， 1份为1rem
    docEl.style.fontSize = rem + 'px';
  }

  win.addEventListener('resize', function() {
    this.clearTimeout(tid);
    tid = setTimeout(refreshRem, 300);
  }, false);

  win.addEventListener('pageshow', function(e) {
    if (e.persisted) {
      this.clearTimeout(tid);
      tid = setTimeout(refreshRem, 300);
    }
  }, false);

  refreshRem();
})(window);